export default function Leadership() {
  const values = [
    {
      title: 'Envolvimento estratégico direto',
      icon: 'ri-focus-3-line'
    },
    {
      title: 'Foco em crescimento sustentável',
      icon: 'ri-plant-line'
    },
    {
      title: 'Decisões orientadas por dados',
      icon: 'ri-pie-chart-line'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Estratégia liderada por quem entende de crescimento
          </h2>
        </div>

        {/* Partners Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 mb-10 sm:mb-12 md:mb-16">
          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 text-center">
            <div className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 mx-auto mb-4 sm:mb-6 rounded-full overflow-hidden border-4 border-teal-600 shadow-xl">
              <img 
                src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/ad78d9501609417c97c7db0fd75d87c6.jpeg" 
                alt="Sócio 1" 
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Sócio Fundador</h3>
            <p className="text-sm sm:text-base text-gray-600">Estratégia e Crescimento</p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 text-center">
            <div className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 mx-auto mb-4 sm:mb-6 rounded-full overflow-hidden border-4 border-teal-600 shadow-xl">
              <img 
                src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/1ab74f7532188ed6a9c7b9c794e96ac4.png" 
                alt="Sócio 2" 
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Sócio Fundador</h3>
            <p className="text-sm sm:text-base text-gray-600">Execução e Performance</p>
          </div>
        </div>

        {/* Vision Text */}
        <div className="max-w-3xl mx-auto mb-10 sm:mb-12 md:mb-16">
          <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed text-center mb-4 sm:mb-6">
            A The One nasceu com um princípio claro: marketing precisa ser tratado como estratégia de negócio.
          </p>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed text-center">
            Os sócios fundadores lideram pessoalmente o direcionamento estratégico dos projetos, garantindo visão, método e consistência nas decisões.
          </p>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-teal-50 p-6 sm:p-8 rounded-xl text-center hover:shadow-lg transition-all group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-600 rounded-lg mb-4 mx-auto group-hover:scale-110 transition-transform">
                <i className={`${value.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-snug">
                {value.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
